import styled from 'styled-components';
import { Button } from 'antd';
import { BASE_COLORS, BORDER_RADIUS, FONT_FAMILY, FONT_SIZE, FONT_SIZE_PX, FONT_WEIGHT, media, TEXT_ALIGN } from 'config/theme/constants';
import { LoginBackgroundIcon } from 'config/IconConfig';
import { BaseForm } from 'components/common/forms/BaseForm';
import { Input as CommonInput } from "components/common/input/Input";
import { InputPassword as CommonInputPassword } from "components/common/input/InputPassword";

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
`;

export const LoginForm = styled.div`
  width: 300px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const LoginTitle = styled.h2`
  text-align: center;
  margin-bottom: 24px;
`;

export const LoginButton = styled(Button)`
  width: 100%;
`;

export const MicrosoftButton = styled(Button)`
  width: 100%;
  background-color: #2F2F2F;
  border-color: #2F2F2F;
  color: white;

  &:hover, &:focus {
    background-color: #1E1E1E;
    border-color: #1E1E1E;
    color: white;
  }
`;

export const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  background: ${BASE_COLORS.black};
`;

export const BackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: url(${LoginBackgroundIcon}) 0% 0% no-repeat padding-box;
  background-size: cover;
  position: relative;
`;

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${TEXT_ALIGN.center};
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);

  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper.ant-input-password {
    background: ${BASE_COLORS.white} 0% 0% no-repeat padding-box;
    border: 1px solid ${BASE_COLORS.dustyGray};
    border-radius: 3px;
    opacity: 1;
    height: 40px;
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
  }

  .ant-input:hover,
  .ant-input:focus {
    border-color: ${BASE_COLORS.dustyGray};
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):focus,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus {
    border-color: ${BASE_COLORS.dustyGray};
  }

  .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover,
  .ant-btn-primary {
    background-color: ${BASE_COLORS.downRiver};
  }

  .ant-btn-primary:disabled {
    color: ${BASE_COLORS.white};
  }
`;
export const FormItem = styled(BaseForm.Item)`
  margin-bottom: 0.75rem;
  & .ant-form-item-control-input {
    min-height: 3.125rem;
  }

  & .ant-form-item-explain-error {
    font-size: ${FONT_SIZE_PX.xs};
  }

  & label {
    color: var(--primary-color);
    font-size: ${FONT_SIZE.xs};
    line-height: 1.25rem;
  }

  &.ant-form-item-has-feedback .ant-input-affix-wrapper .ant-input-suffix {
    padding-right: 1.5rem;
  }
`;

export const FormInput = styled(CommonInput)`
  color: var(--text-main-color);
  background: ${BASE_COLORS.transparent};

  .user-outline {
    font-size: ${FONT_SIZE_PX.xxxxxl};
    color: ${BASE_COLORS.dustyGray};
  }

  & input.ant-input {
    background: ${BASE_COLORS.transparent};
  }
`;

export const FormInputPassword = styled(CommonInputPassword)`
  color: var(--text-main-color);
  background: ${BASE_COLORS.transparent};

  & input.ant-input {
    background: ${BASE_COLORS.transparent};
  }
`;

export const SubmitButton = styled(Button)`
  font-size: ${FONT_SIZE_PX.lg};
  font-weight: ${FONT_WEIGHT.normal};
  width: 100%;
  margin-top: 1rem;
`;

export const InitialInfo = styled.span`
  font-weight: ${FONT_WEIGHT.normal};
  font-size: ${FONT_SIZE_PX.xs};
  font-family: ${FONT_FAMILY.main};
  letter-spacing: 0px;
  color: ${BASE_COLORS.black};
  opacity: 0.5;
`;

export const FormTitle = styled.div`
  color: var(--primary-color);

  @media only screen and ${media.xs} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }

  @media only screen and ${media.md} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }

  @media only screen and ${media.xl} {
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.black};
    text-transform: uppercase;
    opacity: 1;
  }
`;
export const FormWrapper = styled.div`
  padding: 0 2.5rem 2.5rem 2.5rem;
  width: 51.75rem;
  overflow: hidden;
  background-color: ${BASE_COLORS.white};
  border-radius: ${BORDER_RADIUS};

  .logo-container {
    text-align: ${TEXT_ALIGN.center};
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .password-field {
    width: 100%;
  }

  .password-validator-container {
    display: flex;
  }

  @media only screen and ${media.xs} {
    padding: 20px;
    width: 17rem;
    max-height: calc(100vh - 3rem);
  }

  @media only screen and ${media.md} {
    padding: 0 1.5rem 1.5rem 1.5rem;
    width: 18rem;
    max-height: calc(100vh - 3rem);
  }
`;